import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ErrorText from './ErrorText';
import Label from './Label';

const TelInput = ({ name, label, onChange, placeholder, value, error, touched, children, maxLength, onFocus, onBlur, inputRef, inputClass, required, classes }) => {
  const wrapperClass = classNames('form-group', classes, {
    'form-group--has-error': touched && error,
  });

  return (
    <div className={wrapperClass}>
      <Label name={name} required={required}>{label}</Label>

      {children}

      <div className="field">
        <input
          id={name}
          type="tel"
          name={name}
          className={`form-control ${inputClass}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          maxLength={maxLength}
          onFocus={onFocus}
          onBlur={onBlur}
          ref={inputRef}
        />
      </div>

      {touched && error && <ErrorText>{error}</ErrorText>}
    </div>
  );
};

TelInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  maxLength: PropTypes.number,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  inputRef: PropTypes.func,
  inputClass: PropTypes.string,
  required: PropTypes.bool,
  classes: PropTypes.string,
};

export default TelInput;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/TelInput.js